import { AuthRepository } from 'application/repositories/AuthRepository';
import { SignInData, SignUpData, VerifyData, VerifyRegisterData } from 'domain/entities/AuthEntity';
import { MemberBasicInfoResult } from 'domain/entities/UserEntity';
import axiosConfig from 'infrastructure/config/axios';

export class AuthAPI implements AuthRepository {
    async signin(data: SignInData): Promise<any> {
        const API_URL = '/auth/login';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, data);
        return response.data;
    }
    async signup(data: SignUpData): Promise<any> {
        const API_URL = '/auth/sign-up';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, data);
        return response.data;
    }

    async getUserBasicInfo(): Promise<MemberBasicInfoResult> {
        const API_URL = `/member-basic-attributes/get`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async verifyEmail(payload: { email: string }): Promise<any> {
        const API_URL = `/verify-email`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async verifyOtpLogin(payload: VerifyData): Promise<any> {
        const API_URL = `/auth/verify-login`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async resetPassword(payload: { email: string; otp: string; password: string }): Promise<any> {
        const API_URL = `/reset-password`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async changePassword(payload: { oldPassword: string; newPassword: string }): Promise<any> {
        const API_URL = `/mypage/change-password`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async logout(): Promise<any> {
        const API_URL = `/auth/logout`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL);
        return response.data;
    }

    async resendOtp(email: string): Promise<any> {
        const API_URL = `/auth/resend-verify-code`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, { email });
        return response.data;
    }
    async verifyOtpRegister(payload: VerifyRegisterData): Promise<any> {
        const API_URL = `/auth/confirm-sign-up`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }
    async resendOtpRegister(email: string): Promise<any> {
        const API_URL = `/auth/resend-confirm-code`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, { email });
        return response.data;
    }
}
